
import { useOrderConfirmationStore } from "@/store/orderConfirmationStore";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetClose
} from "@/components/ui/sheet";
import { OrderTrackingCard } from "@/components/order/OrderTrackingCard";
import { OrderSummary } from "@/components/order/OrderSummary";
import { Button } from "@/components/ui/button";
import { PartyPopper } from "lucide-react";

export function OrderConfirmationSheet() {
  const { isOpen, order, closeSheet } = useOrderConfirmationStore();

  if (!order) {
    return null;
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeSheet();
    }
  };

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetContent className="w-full sm:max-w-lg flex flex-col p-0">
        <div className="p-6 text-center space-y-2">
            <PartyPopper className="h-12 w-12 text-green-500 mx-auto animate-bounce" />
            <SheetHeader>
                <SheetTitle className="text-2xl">Thank you for your order!</SheetTitle>
            </SheetHeader>
            <p className="text-muted-foreground">
              Your order <span className="font-medium text-primary">#{order.id}</span> has been placed.
            </p>
        </div>

        <div className="flex-1 overflow-auto space-y-8 px-6">
          <OrderTrackingCard order={order} />
          <OrderSummary order={order} />
        </div>

        <div className="text-center p-6 mt-auto">
          <SheetClose asChild>
            <Button className="w-full">Continue Shopping</Button>
          </SheetClose>
        </div>
      </SheetContent>
    </Sheet>
  );
}
